__webpack_require__.p = "/ordercapture/uidispatcher/static/";